var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMacFillBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1615_3507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83351 7.5V8.33333L6.66685 8.75V9.16667H3.33351L3.33185 8.75167L4.16685 8.33333V7.5H1.24685C1.19213 7.49967 1.13802 7.48855 1.08761 7.46727C1.0372 7.44599 0.991491 7.41498 0.953093 7.376C0.914695 7.33702 0.884367 7.29085 0.863847 7.24012C0.843327 7.1894 0.833019 7.13513 0.833513 7.08042V1.66958C0.833513 1.43792 1.0231 1.25 1.24685 1.25H8.75351C8.98184 1.25 9.16685 1.43708 9.16685 1.66958V7.08042C9.16685 7.31208 8.97726 7.5 8.75351 7.5H5.83351ZM1.66685 5.83333V6.66667H8.33351V5.83333H1.66685Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1615_3507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacFillBlack);
export default __webpack_public_path__ + "static/media/mac-fill-black.f2a258cdea058399e4aaa4ce8a40c2b2.svg";
export { ForwardRef as ReactComponent };